module.exports = __webpack_public_path__ + "assets/img/ic-export-p.2654582f.svg";